import { render, staticRenderFns } from "./ListadoDocumentos.vue?vue&type=template&id=4b991a02&scoped=true&"
import script from "./ListadoDocumentos.vue?vue&type=script&lang=js&"
export * from "./ListadoDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ListadoDocumentos.vue?vue&type=style&index=0&id=4b991a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b991a02",
  null
  
)

export default component.exports